import moment from 'moment';

export function convertToCustomDateFormat(date: Date, format?: string) {
  if (!format) {
    return convertToIsoDateFormat(date);
  }
  return moment(date).format(format);
}

export function convertToIsoDateFormat(date: Date) {
  return moment(date).format('YYYY-MM-DD');
}
